<template>
  <LayoutContainer class="text-center">
    <h2 class="mb-8 text-lg font-bold uppercase tracking-wide">
      The job {{ title }} by {{ brand?.name }} is no longer available
    </h2>

    <NuxtLink class="btn" to="/">Back to homepage</NuxtLink>
  </LayoutContainer>
</template>

<script setup lang="ts">
import type { QueryOpportunities } from "~/@types/opportunities"

const props = defineProps<{
  post: QueryOpportunities
}>()

const { post } = toRefs(props)

const { title, brand } = useOpportunities(post.value)
</script>
